import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { DefaultResponseWithData } from "../models/system";
import { CreateUpdateListingRestrictionRuleRequest, IListingRestrictionRule } from "../models/ListingRestriction";

export default function useListingRestrictions() {
  const { get, post, put, del } = useApiHelper();
  const queryClient = useQueryClient();
  const staleTime = 1000 * 60 * 10;

  const listingRestrictions = useQuery({
    queryKey: ["listingRestrictions"],
    queryFn: () => get<DefaultResponseWithData<IListingRestrictionRule[]>>("/listingrestriction"),
    staleTime,
  });

  // A rule changes which parts the Unlisted table and the ready-to-list counts show
  const invalidate = () => {
    queryClient.invalidateQueries(["listingRestrictions"]);
    queryClient.invalidateQueries(["parts"]);
  };

  const create = useMutation(
    (req: CreateUpdateListingRestrictionRuleRequest) => post(`/listingrestriction`, req),
    { onSuccess: invalidate }
  );

  const update = useMutation(
    (params: { id: string; req: CreateUpdateListingRestrictionRuleRequest }) =>
      put(`/listingrestriction/${params.id}`, params.req),
    { onSuccess: invalidate }
  );

  const remove = useMutation(
    (id: string) => del(`/listingrestriction/${id}`),
    { onSuccess: invalidate }
  );

  return { listingRestrictions, create, update, remove };
}
